import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigurationService, RoleListDto } from '../configuration.service';

interface DialogData { userId: number; assignedRoleIds: number[]; }

@Component({
  selector: 'app-user-role-assign-dialog',
  templateUrl: './user-role-assign-dialog.component.html',
  styleUrls: ['../configuration-form.css'],
})
export class UserRoleAssignDialogComponent implements OnInit {
  availableRoles: RoleListDto[] = [];
  selectedRoleId: number | null = null;
  submitting = false;

  constructor(
    private api: ConfigurationService,
    private dialogRef: MatDialogRef<UserRoleAssignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.api.getRoles().subscribe({
      next: roles => {
        this.availableRoles = roles.filter(r => !this.data.assignedRoleIds.includes(r.id));
      }
    });
  }

  submit(): void {
    if (!this.selectedRoleId || this.submitting) return;
    this.submitting = true;
    this.api.assignRole(this.data.userId, this.selectedRoleId).subscribe({
      next: () => this.dialogRef.close({ assigned: true }),
      error: () => { this.submitting = false; }
    });
  }

  cancel(): void { this.dialogRef.close(); }
}
